// extracted by mini-css-extract-plugin
export default {"modalMessageWrap":"L_TDtkZ06hgZQcvrJogN","title":"VJR7pB18KATsaCB7bbxX","detail":"zXVK_OibLMij7Uc4XpYz"};